






















































































































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { SearchItemType } from '../../types/type'
@Component({
  name: 'SearchModule',
  components: {
    'concise-card': () => import('../common/conciseCard.vue')
  }
})
export default class SearchModule extends Vue {
  @Prop({ default: () => [] }) public searchList: SearchItemType[]
  @Prop({ default: () => [] }) public searchCheckList: string[]
  @Prop({ default: '' }) public icon: string
  @Prop({ default: '' }) public title: string
  @Prop({ default: '' }) public titleWidth: string

  public searchCheckListSelf: string[] = []

  @Watch('searchCheckList', { immediate: true })
  searchCheckListChange () {
    this.searchCheckListSelf = this.searchCheckList
  }

  resetBtn () {
    this.$emit('resetBtn')
  }

  searchBtn () {
    this.$emit('searchBtn', this.searchCheckListSelf)
  }
}
